export interface MatrixMembershipStatus {
  status: 'not_requested' | 'pending' | 'joined' | 'left' | 'failed'
  error_code?: string | null
  retry_at?: string | null
  checked_at?: string | null
}

export function membershipFailureMessage(code?: string | null): string {
  if (code === 'room_state_missing' || code === 'room_not_found' || code === 'room_empty') {
    return 'Комната недоступна. Сообщите администратору.'
  }
  if (code === 'http_403' || code === 'PermissionDeniedError') {
    return 'Не удалось подтвердить доступ к чату. Повторите подключение.'
  }
  return 'Не удалось подключиться к чату. Повторите подключение.'
}

/** A lost HTTP response must not create a second command before reading status. */
export async function awaitMembershipOperation(options: {
  request: () => Promise<MatrixMembershipStatus>
  read: () => Promise<MatrixMembershipStatus>
  onStatus: (status: MatrixMembershipStatus) => void
  sleep: (ms: number) => Promise<void>
  attempts?: number
}): Promise<boolean> {
  let state: MatrixMembershipStatus
  try {
    state = await options.request()
  } catch (error: any) {
    if (error?.response?.status && error.response.status < 500) {
      throw error
    }
    state = await options.read()
  }
  for (let i = 0; ; i += 1) {
    options.onStatus(state)
    if (state.status === 'joined') {
      return true
    }
    if (state.status === 'failed' || state.status === 'left' || i >= (options.attempts ?? 12)) {
      return false
    }
    const due = state.retry_at ? Date.parse(state.retry_at) : 0
    if (Number.isFinite(due) && due - Date.now() > 15_000) {
      return false
    }
    await options.sleep(800)
    state = await options.read()
  }
}
